import styled from '@emotion/styled'

import { typography } from '../constants'
import Text from './Text'

export default styled(Text)`
  color: ${({ color }) => color};
  font-size: ${typography.fontSize.tag};
  font-weight: ${typography.fontWeight.bold};
  line-height: 18px;
  text-transform: uppercase;
`
